import React, { useState } from "react";
import { isEmpty } from "lodash";
import { TextField, theme, Stack, Autocomplete } from "@hiver/hiver-ui-kit";

const CreateSMTypeDropdown = ({
  dropdownlist,
  onValueChange,
  errorText = "",
}) => {
  const [selectedDropdownValue, setSelectedDropdownValue] = useState("");

  const isOthers = (value) => value.toLowerCase() === "others";

  const handleSelect = (option) => {
    setSelectedDropdownValue(option);
    onValueChange((isOthers(option) ? "" : option), true);
  };

  const handleCustomValueChange = (event) => {
    const value = event.target.value;
    onValueChange(value, true);
  };

  const handleCustomValueFocus = (event) => {
    onValueChange(event.target.value);
  };

  const onBlurHandler = () => {
    onValueChange(selectedDropdownValue);
  };

  const filteredOptions = (options, state) => {
    const searchValue = state.inputValue.toLowerCase();
    if (isEmpty(searchValue)) return options;
    return options.filter(
      (option) => option.toLowerCase().includes(searchValue) || isOthers(option)
    );
  };

  const otherOptionSelected = isOthers(selectedDropdownValue);

  const textFieldStyles = {
    width: theme.spacing(50),
    marginBottom: theme.spacing(2),
    "& .MuiOutlinedInput-root": {
      color: !selectedDropdownValue && theme.palette.gray.gray4,
      backgroundColor: !selectedDropdownValue && "#f4f4f4",
      marginLeft: "-10px;",
      marginBottom: "15px;",
      height: "41px;",
      borderRadius: "17.5px;",
    },
    "& .MuiFormHelperText-root": {
      position: "absolute",
      right: theme.spacing(-2),
      top: theme.spacing(-3.5),
    },
  };

  return (
    <Stack>
      <Autocomplete
        freeSolo={false}
        value={selectedDropdownValue}
        options={dropdownlist}
        onChange={(e, newValue) => {
          handleSelect(newValue || "");
        }}
        filterOptions={filteredOptions}
        onBlur={onBlurHandler}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Please select"
            variant="outlined"
            sx={textFieldStyles}
            error={!otherOptionSelected && Boolean(errorText)}
            helperText={!otherOptionSelected && errorText}
            SelectProps={{
              MenuProps: {
                PaperProps: {
                  sx: {
                    maxHeight: "220px",
                  },
                },
              },
            }}
          />
        )}
      />
      {otherOptionSelected && (
        <TextField
          variant="outlined"
          onChange={handleCustomValueChange}
          onFocus={handleCustomValueFocus}
          sx={textFieldStyles}
          limit={50}
          error={Boolean(errorText)}
          helperText={errorText}
        />
      )}
    </Stack>
  );
};

export default CreateSMTypeDropdown;
